import { render, staticRenderFns } from "./required-span.vue?vue&type=template&id=887da066"
import script from "./required-span.vue?vue&type=script&lang=js"
export * from "./required-span.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports